module.exports = __webpack_public_path__ + "92c593c39c7421dc7eec374dcb7544e9.jpg";